import { render, staticRenderFns } from "./TableCard.vue?vue&type=template&id=5033b549&"
import script from "./TableCard.vue?vue&type=script&lang=ts&"
export * from "./TableCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports